import React from 'react';
import P from 'prop-types';
import './styles.css';
import { ShimmerBanner } from '../../templates/ShimmerBanner';
import { ShimmerCategorias } from '../../templates/ShimmerCategorias';
import { ShimmerProdutos } from '../../templates/ShimmerProdutos';

export const Shimmer = ({ type }) => {
  return (
    <>
      <div className="shimmer-container">
        {type === 'Banner' && <ShimmerBanner />}
        {type === 'Categorias' && <ShimmerCategorias />}
        {type === 'Produtos' && <ShimmerProdutos />}
      </div>
    </>
  );
};

Shimmer.propTypes = {
  type: P.string.isRequired,
};
